import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';
import { CustomerProfile } from '@/models';
import { AccountManagementEvent } from '@/services/analytics/events';
import { isLoyaltyEnabled } from '@/helpers/country';

@Component({
  name: 'CmgSignIn',
})
export default class CmgSignIn extends Vue {

  get countryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  get logoImageSrc(): string {
    let src = '';

    if (isLoyaltyEnabled(this.countryCode)) {
      src = this.$services.config.getSignInModal()?.imageUrl || this.$appStore.state.cms.images.logos.medallionReward.default;
    } else {
      src = this.$services.config.getSignInModal()?.imageUrl || this.$appStore.state.cms.images.logos.medallion.default;
    }

    return src;
  }

  get withPaddingBottom(): boolean {
    return this.$router.currentRoute.name !== Routes.VendorSignIn;
  }

  get signInFormProps(): object {
    return this.$router.currentRoute.name === Routes.VendorSignIn
      ? {
          initialFormState: { rememberMe: false },
          renderRememberMe: false,
          renderCountryFlag: false,
        }
      : {};
  }

  get customer(): CustomerProfile | null {
    const profile = this.$appStore.state.customer.profile;
    return profile && !profile.isGuest ? profile : null;
  }

  get headingText(): string {
    return  this.$router.currentRoute.name === Routes.VendorSignIn 
      ? 'Join Chipotle Rewards Or Sign In To Play'
      : this.$services.config.getSignInModal()?.heading || 'Sign In';
  }

  onSignIn(): void {
    if (this.$router.currentRoute.name === Routes.VendorSignIn) {
      return;
    }
    const path = this.$route.query['path'] as string;
    if (path) {
      this.$router.replace(path);
    } else {
      this.$router.replace({ name: Routes.Home });
    }
    
    this.$services.adobeTarget.sendAdobeTargetExperienceRequest(this.$route.name); 
    this.$services.analytics.send(new AccountManagementEvent('logins'));
  }
}
